"use client";

import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import JobApplicationForm from "../components/JobApplicationForm";
import styles from "../styles/Jobs.module.css";

const Job = () => {
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const [sessionId, setSessionId] = useState("");
  const [showApplicationForm, setShowApplicationForm] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  const getNewSessionId = async () => {
    console.log("getting new session id");
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/web/session/authenticate`,
        {
          jsonrpc: "2.0",
          params: {
            db: "ProdClone",
            login: import.meta.env.VITE_API_AUTH_USERNAME,
            password: import.meta.env.VITE_API_AUTH_PASSWORD,
          },
        },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const match = document.cookie.match(/(?:^|;\s*)session_id=([^;]*)/);
      return match ? match[1] : "cookie-managed";
    } catch (error) {
      console.error("Failed to get session ID:", error);
      return null;
    }
  };

  const fetchJob = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/api/job`,
        { id },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      const jobDetail = response.data?.result?.result ?? {};
      setJob(jobDetail);
    } catch (err) {
      console.error("Failed to fetch job:", err);
      setJob(null); // Ensure job is null on error
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    console.log("initializing session");
    const initializeSession = async () => {
      const newSessionId = await getNewSessionId();
      if (newSessionId) {
        console.log("setting new session id");
        setSessionId(newSessionId);
      }
    };
    initializeSession();
  }, []);

  useEffect(() => {
    if (sessionId) {
      console.log("getting job");
      fetchJob();
    }
  }, [sessionId, fetchJob]);

  useEffect(() => {
    console.log(`got job ${JSON.stringify(job)}`);
  }, [job]);

  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setShowApplicationForm(true);
  };

  const handleCloseApplicationForm = () => {
    setShowApplicationForm(false);
    setSelectedJob(null);
  };

  const handleBackClick = () => {
    navigate("/jobs");
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date) ? null : date.toLocaleDateString();
  };

  const formattedDate = job?.createdAt ? formatDate(job.createdAt) : null;

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <div className={styles.maxWidth}>
          <button
            onClick={handleBackClick}
            style={{
              backgroundColor: "green",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "10px",
              marginBottom: "20px",
              cursor: "pointer",
            }}
          >
            ← Back
          </button>
          <p className={styles.blogTitle}>ARIF JOBS</p>
          {job && <h2>{job.title}</h2>}
        </div>
      </div>

      {loading ? (
        <p style={{ textAlign: "center", margin: "2rem" }}>Loading job...</p>
      ) : !job ? (
        <p style={{ textAlign: "center", margin: "2rem" }}>
          No job found. Please refresh.
        </p>
      ) : (
        <div className={styles.internationalPaymentsSection}>
          <div className={styles.paymentDetails}>
            <h2>{job.title}</h2>
            <div style={{ color: "gray", margin: "10px 0" }}>
              <div
                style={{ marginTop: "8px" }}
                dangerouslySetInnerHTML={{
                  __html: job.description || "<p>No description available</p>",
                }}
              />
            </div>

            {job.location && (
              <div className={styles.locationContainer}>
                <p className={styles.locationText}>{job.location}</p>
              </div>
            )}

            {formattedDate && (
              <div className={styles.locationContainer}>
                <p className={styles.locationText}>{formattedDate}</p>
              </div>
            )}

            <button
              onClick={() => handleApplyClick(job)}
              style={{
                backgroundColor: "green",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "10px",
                marginTop: "20px",
                cursor: "pointer",
              }}
            >
              Apply Now →
            </button>
          </div>
        </div>
      )}

      <JobApplicationForm
        jobTitle={selectedJob?.title || ""}
        jobId={selectedJob?.id || ""}
        isOpen={showApplicationForm}
        onClose={handleCloseApplicationForm}
      />

      <Footer />
    </div>
  );
};

export default Job;